import {API_BASE_URL} from "../config/apiConfig";

export interface RegularHoursResponse {
    periodKey: string;
    workingDays: number;
    standardHoursPerDay: number;
    regularHours: number;
}

/** GET /api/work-evidence/regular-hours — backend-computed regular hours for a period. Throws on non-2xx. */
export const getRegularHours = async (token: string, periodKey: string): Promise<RegularHoursResponse> => {
    const response = await fetch(
        `${API_BASE_URL}/api/work-evidence/regular-hours?periodKey=${encodeURIComponent(periodKey)}`,
        {
            method: "GET",
            headers: {"Content-Type": "application/json", Authorization: `Bearer ${token}`},
        },
    );
    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `Failed to fetch regular hours: ${response.statusText}`);
    }
    return response.json();
};

export interface BranchEvidenceSummary {
    branchId: string;
    total: number;
    pending: number;
    submitted: number;
    approved: number;
    inPreparation: number;
}

/** GET /api/work-evidence/summary — per-branch total/pending/submitted evidence counts for all branches in one request. */
export const getWorkEvidenceSummary = async (token: string, periodKey: string): Promise<BranchEvidenceSummary[]> => {
    const response = await fetch(
        `${API_BASE_URL}/api/work-evidence/summary?periodKey=${encodeURIComponent(periodKey)}`,
        {
            method: "GET",
            headers: {"Content-Type": "application/json", Authorization: `Bearer ${token}`},
        },
    );
    if (!response.ok) {
        throw new Error(`Failed to fetch work evidence summary: ${response.statusText}`);
    }
    return response.json();
};
